import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "App-Oppp-Startup" }
const _hoisted_2 = {
  key: 0,
  class: "App-Opp-Star-C"
}
const _hoisted_3 = { class: "App-Opp-Star-C-B" }
const _hoisted_4 = { class: "App-Opp-Star-C" }
const _hoisted_5 = { class: "App-Opp-Star-C-B" }
const _hoisted_6 = { class: "App-Opp-Star-C" }
const _hoisted_7 = { class: "App-Opp-Star-C-B" }
const _hoisted_8 = { class: "App-Opp-Star-C" }
const _hoisted_9 = { class: "App-Opp-Star-C-B" }
const _hoisted_10 = { class: "App-Opp-Star-C" }
const _hoisted_11 = {
  key: 0,
  class: "App-Opp-Star-C-B"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "App-Opp-Star-C" }
const _hoisted_15 = { class: "App-Opp-Star-C-B" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "App-Opp-Star-C" }
const _hoisted_19 = { class: "App-Opp-Star-C-B" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "App-Opp-Star-C" }
const _hoisted_22 = { class: "App-Opp-Star-C-B" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "App-Opp-Star-C" }
const _hoisted_25 = { class: "App-Opp-Star-C-B" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showHeader)
      ? (_openBlock(), _createBlock(_component_app_section_divider, {
          key: 0,
          content: "Startup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_OfficeBuilding)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.business.website)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "App-Opp-Star-C-S",
              "mute-secondary": ""
            }, "Website Url", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_link, {
                target: "__blank",
                href: _ctx.business.website,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.business.website), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", {
                class: "App-Opp-Star-C-S",
                "mute-secondary": ""
              }, "Founders", -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.business.coFoundersSize + 1), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "App-Opp-Star-C-S",
                "mute-secondary": ""
              }, "Team Size", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.business.teamSize), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("div", {
                class: "App-Opp-Star-C-S",
                "mute-secondary": ""
              }, "Founding Year", -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.business.foundingYear), 1)
            ])
          ]),
          _: 1
        }),
        (_ctx.business.marketSize !== undefined)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", {
                    class: "App-Opp-Star-C-S",
                    "mute-secondary": ""
                  }, "Market Size", -1)),
                  (_ctx.business.marketSize)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (typeof _ctx.business.marketSize === 'number')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$filters.number(_ctx.business.marketSize)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.business.marketSize), 1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        (_ctx.business.funding !== undefined)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", {
                    class: "App-Opp-Star-C-S",
                    "mute-secondary": ""
                  }, "Fund Raised", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (
                typeof _ctx.business.funding === 'object' &&
                _ctx.business.funding !== null
              )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString((_ctx.business.funding.currency + "").toLocaleUpperCase()) + " " + _toDisplayString(_ctx.$filters.number(_ctx.business.funding.amount)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.business.funding), 1))
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _cache[6] || (_cache[6] = _createElementVNode("div", {
                class: "App-Opp-Star-C-S",
                "mute-secondary": ""
              }, "Industry", -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.business.industry), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.business.nextStage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_el_divider),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", {
                      class: "App-Opp-Star-C-S",
                      "mute-secondary": ""
                    }, "Next Stage", -1)),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.business.nextStage), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.business.skillsNeeded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_el_divider),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", {
                      class: "App-Opp-Star-C-S",
                      "mute-secondary": ""
                    }, "Needed Skills", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_space, {
                        wrap: "",
                        "m-tb-5px": "",
                        size: 12
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business.skillsNeeded, (skill, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              round: "",
                              key: `skill-${skill.name}${index}`,
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(skill.name.join(", "))), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}